
/**
 * 트윗 태그 정보
 */
export type TweetListResponsePageAllOfThreeContentItemTags = {
  hashtags?: string[];
};
